import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Card, Row, Col, Input, Tooltip, Space, Select } from 'antd';
import { SearchIcon, AddIcon } from '@chakra-ui/icons';
import { FiAlertTriangle } from 'react-icons/fi';
import TaskObject from '@atlaskit/object/task';
import StoryObject from '@atlaskit/object/story';
import BugObject from '@atlaskit/object/bug';
import SubTaskModal from './SubTaskModal';
import { RotateCw } from 'lucide-react';
import { RedoOutlined } from '@ant-design/icons';
import SprintPopover from './SprintDetail';
import { Switch } from 'antd';

import {
  Button,
  IconButton,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Box,
  Flex,
  Portal,
  Text,
} from '@chakra-ui/react';
import { FilterOutlined } from '@ant-design/icons';
import axios from 'axios';
import { useParams } from 'react-router-dom';
// import Select from 'react-dropdown-select';
import httpInjectorService from 'services/http-injector.service';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import {
  FiMoreVertical,
  FiEdit,
  FiMoreHorizontal,
  FiDelete,
} from 'react-icons/fi';
import { DeleteIcon } from '@chakra-ui/icons';
import { useDispatch } from 'react-redux';
// import {settaskBoardDetails } from 'store/actions';
import { settaskBoardDetails } from 'store/actions';
import { settaskstatuscount } from 'store/actions';
import { setTaskstatuslist } from 'store/actions';
import { setassigneelist } from 'store/actions';
import SkeletonWithLoaders from 'components/common/Spinner';
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
} from '@chakra-ui/react';
import { MdOutlinePerson, MdOutlineCalendarToday } from 'react-icons/md';
import { toast } from 'react-toastify';
import {
  DndContext,
  useSensor,
  useSensors,
  PointerSensor,
  DragOverlay,
  useDroppable,
  closestCenter,
  pointerWithin,
  rectIntersection,
} from '@dnd-kit/core';
import {
  useSortable,
  SortableContext,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
// import TaskModal from '../TaskManagement/TaskModal';
import TaskCard from './TaskCard';
import TaskModal from './TaskModal';
import OptionModal from './OptionMenu';
import OptionMenu from './OptionMenu';
import EmployeeFilterMenu from './Employeelist';
import { horizontalListSortingStrategy } from '@dnd-kit/sortable';
import SprintModal from './Sprintmodal';
import UserAvatar from '../../../../components/userAvatar/index';
import CompleteSprintModal from './CompleteSprintModal';
import FilterDropdownPanel from './Filter';
import { useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import Deletestatus from './Deletestatus';
import EpicList from './EpicList';
import { unparse } from 'papaparse';
const findColumn = (tasks, id) =>
  Object.keys(tasks).find((col) => tasks[col].some((t) => t.id === id));
const roleId = Number(Cookies.get('task-role-id'));

const canDragTask = [1, 2, 3].includes(roleId);

// const TaskCard = ({
//   task,
//   assigneeList,
//   columnId,
//   onOpenModal,
//   openOptionModal,
// }) => {
//   console.log(task, "taskkked")
//   const {
//     attributes,
//     listeners,
//     setNodeRef,
//     transform,
//     transition,
//     isDragging,
//   } = useSortable({
//     id: task.id,
//     data: {
//       type: 'task',
//       columnId, // 🔥 use columnId passed from parent
//       statusName: task.status_name, // optional
//     },
//   });
//   const dragProps = canDragTask ? { ...attributes, ...listeners } : {};

//   const [title, setTitle] = useState(task.title);
//   const [assigneeId, setAssigneeId] = useState(task.assignee_id || null);
//   const [assigneeName, setAssigneeName] = useState(task.assignee_name || '');
//   const [selectedEmployee, setSelectedEmployee] = useState(null);
//   const [isEditingTitle, setIsEditingTitle] = useState(false);
//   const [showEmployeePicker, setShowEmployeePicker] = useState(false);
//   const project_id = useParams();

//   const menuButtonRef = useRef();
//   const employeePopoverRef = useRef();
//   const [showOptionMenu, setShowOptionMenu] = useState(false);

//   useEffect(() => {
//     setAssigneeName(task.assignee_name);
//     setAssigneeId(task.assignee_id);
//   }, [task]);

//   // Sync selectedEmployee with assigneeId
//   useEffect(() => {
//     if (!assigneeList || !Array.isArray(assigneeList)) {
//       setSelectedEmployee(null);
//       return;
//     }
//     const found = assigneeList.find((emp) => emp.id === assigneeId) || null;
//     setSelectedEmployee(found);
//     if (found) setAssigneeName(found.name || found.username);
//   }, [assigneeId, assigneeList]);

//   const handleCardClick = (e) => {
//     const isInsideUI =
//       e.target.closest('button') ||
//       e.target.closest('select') ||
//       e.target.closest('input') ||
//       e.target.closest('[role="dialog"]');
//     if (!isInsideUI && onOpenModal) {
//       onOpenModal(task);
//     }
//   };

//   const handleOpenMenu = (e) => {
//     e.stopPropagation(); // Prevent card click
//     setShowOptionMenu(true);
//   };

//   const handleCloseMenu = () => {
//     setShowOptionMenu(false);
//   };

//   const handleUpdate = async (newTitle, newAssigneeId) => {
//     const updatedTitle = newTitle ?? title;
//     const updatedAssigneeId = newAssigneeId ?? assigneeId;

//     const hasTitleChanged = updatedTitle !== task.title;
//     const hasAssigneeChanged = updatedAssigneeId !== task.assignee_id;

//     if (!hasTitleChanged && !hasAssigneeChanged) return;

//     try {
//       await httpInjectorService.TaskUpdateTitleAssignee({
//         project_id: project_id.id,
//         task_id: task.id,
//         task_title: updatedTitle,
//         assignee_id: updatedAssigneeId,
//         task_status: task.task_status,
//       });

//       setTitle(updatedTitle);
//       setAssigneeId(updatedAssigneeId);
//     } catch (err) {
//       console.error('Failed to update task:', err);
//     }
//   };

//   const handleAssigneeSelect = async (emp) => {
//     setSelectedEmployee(emp);
//     setAssigneeId(emp.user_id);
//     setAssigneeName(emp.username);
//     setShowEmployeePicker(false);
//     await handleUpdate(undefined, emp.user_id);
//   };

//   const initials = assigneeName
//     ? assigneeName
//         .split(' ')
//         .map((part) => part[0])
//         .join('')
//         .toUpperCase()
//     : null;

//   return (
//     <div
//       ref={setNodeRef}
//       {...attributes}
//       {...listeners}
//       {...dragProps}
//       style={{
//         transform: CSS.Transform.toString(transform),
//         transition,
//         opacity: isDragging ? 0.5 : 1,
//         marginBottom: 1,
//         marginTop: 2,
//         cursor: 'grab',
//         width: '100%',
//       }}
//       onClick={handleCardClick}
//     >
//       <div
//         style={{
//           width: '100%',
//           minHeight: 130,
//           padding: 15,
//           background: '#fff',
//           position: 'relative',
//           border: '1px solid #eee',
//           borderRadius: 6,
//           boxShadow: '0 0 16px rgba(0, 0, 0, 0.1)',
//           boxSizing: 'border-box',
//           overflow: 'hidden',
//           textOverflow: 'ellipsis',
//         }}
//       >
//         {/* Title Row */}
//         <div
//           style={{
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'space-between',
//             marginBottom: 16,
//           }}
//         >
//           {isEditingTitle ? (
//             <input
//               type="text"
//               value={title}
//               onChange={(e) => setTitle(e.target.value)}
//               onBlur={() => {
//                 setIsEditingTitle(false);
//                 handleUpdate(title, undefined);
//               }}
//               onKeyDown={(e) => {
//                 if (e.key === 'Enter') {
//                   setIsEditingTitle(false);
//                   handleUpdate(title, undefined);
//                 }
//               }}
//               autoFocus
//               onClick={(e) => e.stopPropagation()}
//               style={{
//                 fontSize: 16,
//                 width: '100%',
//                 padding: '4px 8px',
//               }}
//             />
//           ) : (
//             <>
//               <div
//                 style={{
//                   fontSize: 16,
//                   flexGrow: 1,
//                   whiteSpace: 'nowrap',
//                   overflow: 'hidden',
//                   textOverflow: 'ellipsis',
//                   maxWidth: 'calc(100% - 64px)',
//                 }}
//                 title={title}
//               >
//                 {title}
//               </div>
//               <button
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   setIsEditingTitle(true);
//                 }}
//                 style={{
//                   background: 'none',
//                   border: 'none',
//                   cursor: 'pointer',
//                   color: '#666',
//                 }}
//               >
//                 <FiEdit size={16} />
//               </button>
//               <span
//                 ref={menuButtonRef}
//                 style={{ cursor: 'pointer', display: 'inline-flex' }}
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   if (typeof openOptionModal === 'function') {
//                     openOptionModal(task, menuButtonRef);
//                   } else {
//                     console.error(
//                       'openOptionModal is not a function:',
//                       openOptionModal,
//                     );
//                   }
//                 }}
//               >
//                 <FiMoreHorizontal size={18} />
//               </span>
//             </>
//           )}
//         </div>
//         {/* epiclabel */}
//         {/* Bottom Labels */}
//         <div
//           style={{
//             position: 'absolute',
//             bottom: 12, // distance from bottom (adjust as needed)
//             left: 16,
//             display: 'flex',
//             flexDirection: 'column',
//             gap: '4px',
//           }}
//         >
//           {/* Epic Name */}
//           {task?.task?.epic_name && (
//             <div
//               style={{
//                 fontSize: 11,
//                 color: '#5B21B6',
//                 fontWeight: 500,
//                 backgroundColor: '#E9D8FD',
//                 padding: '1px 8px',
//                 borderRadius: 4,
//                 maxWidth: '95%',
//                 whiteSpace: 'nowrap',
//                 overflow: 'hidden',
//                 textOverflow: 'ellipsis',
//               }}
//               title={task?.task?.epic_name}
//             >
//               {task?.task?.epic_name}
//             </div>
//           )}

//           {/* Due Date (only if past due) */}
//           {task?.task?.end_date &&
//             new Date(task.task.end_date) < new Date() && (
//               <div
//                 style={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   gap: '4px',
//                   border: '1px solid #DC2626',
//                   color: '#DC2626',
//                   fontSize: 11,
//                   fontWeight: 500,
//                   padding: '1px 8px',
//                   borderRadius: 4,
//                   backgroundColor: '#FFF5F5',
//                   maxWidth: 'fit-content',
//                 }}
//                 title={`Due: ${new Date(task.task.end_date).toLocaleDateString(
//                   'en-US',
//                   {
//                     month: 'short',
//                     day: 'numeric',
//                     year: 'numeric',
//                   },
//                 )}`}
//               >
//                 <FiAlertTriangle size={14} />
//                 {new Date(task.task.end_date).toLocaleDateString('en-US', {
//                   month: 'short',
//                   day: 'numeric',
//                   year: 'numeric',
//                 })}
//               </div>
//             )}

//           {/* Task Key */}
//           <div
//             style={{
//               fontSize: 11,
//               color: '#666',
//               fontWeight: 500,
//               backgroundColor: '#f1f1f1',
//               padding: '1px 8px',
//               borderRadius: 4,
//               maxWidth: 'fit-content',
//               whiteSpace: 'nowrap',
//               overflow: 'hidden',
//               textOverflow: 'ellipsis',
//             }}
//             title={task?.task?.task_key}
//           >
//             {task?.task?.task_key || 'No Epic'}
//           </div>
//         </div>

//         {/* Assignee Popover */}
//         <div
//           style={{
//             position: 'absolute',
//             bottom: 16,
//             right: 16,
//             display: 'flex',
//             alignItems: 'center',
//           }}
//         >
//           <Popover
//             isOpen={showEmployeePicker}
//             onClose={() => setShowEmployeePicker(false)}
//             placement="top-end"
//           >
//             <PopoverTrigger>
//               <span
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   setShowEmployeePicker(!showEmployeePicker);
//                 }}
//                 style={{
//                   display: 'inline-flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   cursor: 'pointer',
//                 }}
//                 title={assigneeName || 'Unassigned'}
//               >
//                 {assigneeName ? (
//                   <UserAvatar username={assigneeName} size={24} />
//                 ) : (
//                   <MdOutlinePerson size={20} color="#999" />
//                 )}
//               </span>
//             </PopoverTrigger>
//             <Portal>
//               <PopoverContent
//                 ref={employeePopoverRef}
//                 width="auto"
//                 zIndex={9999}
//               >
//                 <PopoverBody>
//                   {assigneeList?.length > 0 ? (
//                     <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
//                       {assigneeList.map((emp) => (
//                         <Flex
//                           key={emp.user_id}
//                           align="center"
//                           p="6px 10px"
//                           borderRadius="6px"
//                           cursor="pointer"
//                           bg={
//                             selectedEmployee?.user_id === emp.user_id
//                               ? '#e6f4ff'
//                               : 'transparent'
//                           }
//                           _hover={{ background: '#f0f0f0' }}
//                           onClick={(e) => {
//                             e.stopPropagation();
//                             handleAssigneeSelect(emp);
//                           }}
//                         >
//                           <Box w="24px" h="24px" mr="8px">
//                             <UserAvatar username={emp.username} size={24} />
//                           </Box>
//                           <Box fontSize="14px" color="#333">
//                             {emp.username}
//                           </Box>
//                         </Flex>
//                       ))}
//                     </div>
//                   ) : (
//                     <div style={{ fontSize: 12, color: '#888' }}>
//                       No employees found
//                     </div>
//                   )}
//                 </PopoverBody>
//               </PopoverContent>
//             </Portal>
//           </Popover>
//         </div>
//       </div>
//     </div>
//   );
// };

// const DroppableColumn = ({
//   columnKey,
//   columnId,
//   onDeleteColumn,
//   tasks,
//   taskCount,
//   renderCreate,
//   hovered,
//   onHover,
//   assigneeList,
//   onOpenModal,
//   handleOpenOptionMenu,
//   maxHeight,
//   updateHeight,
// }) => {
//   console.log(columnId, 'columnId');
//   const { setNodeRef } = useDroppable({ id: columnId });
//   const validTasks = Array.isArray(tasks) ? tasks.filter(Boolean) : [];
//   const roleId = Number(Cookies.get('task-role-id'));

//   const columnRef = useRef(null);

//   // Measure own column height and update maxHeight in parent
//   useEffect(() => {
//     if (columnRef.current) {
//       updateHeight(columnRef.current.scrollHeight);
//     }
//   }, [validTasks.length]);

//   return (
//     <div
//       ref={columnRef}
//       style={{
//         flex: 1,
//         minWidth: '260px',
//         maxWidth: '320px',
//         height: maxHeight, // 🔑 all columns use tallest height
//         display: 'flex',
//         flexDirection: 'column',
//         marginTop: -30,
//       }}
//     >
//       <Card
//         style={{
//           flex: 1,
//           display: 'flex',
//           flexDirection: 'column',
//           backgroundColor: '#fafafa',
//         }}
//         bodyStyle={{
//           flex: 1,
//           display: 'flex',
//           flexDirection: 'column',
//           padding: 0,
//         }}
//       >
//         <div
//           style={{
//             padding: '10px 12px',
//             fontWeight: 'bold',
//             display: 'flex',
//             justifyContent: 'space-between',
//             alignItems: 'center', // changed from "stretch" to "center"
//             borderBottom: '1px solid #ddd',
//             position: 'sticky',
//             top: 0,
//             zIndex: 1,
//             backgroundColor: 'whitesmoke',
//           }}
//         >
//           <span>
//             {columnKey}{' '}
//             <span style={{ color: '#666', fontWeight: 'normal' }}>
//               ({taskCount})
//             </span>
//           </span>

//           {[1, 2].includes(roleId) && !['TO DO', 'DONE'].includes(columnKey) ? (
//             <Menu>
//               <MenuButton
//                 as={IconButton}
//                 icon={<FiMoreHorizontal size={18} />}
//                 size="sm"
//                 variant="ghost"
//                 aria-label="Options"
//               />
//               <MenuList>
//                 <MenuItem
//                   icon={<DeleteIcon color="red" boxSize={4} />}
//                   onClick={() => onDeleteColumn(columnId, columnKey)}
//                 >
//                   Delete
//                 </MenuItem>
//               </MenuList>
//             </Menu>
//           ) : (
//             <IconButton
//               icon={<FiMoreHorizontal size={18} />}
//               size="sm"
//               variant="ghost"
//               aria-label="Options"
//               style={{ visibility: 'hidden' }}
//             />
//           )}
//         </div>

//         {/* Scrollable task list */}
//         <div
//           ref={setNodeRef}
//           onMouseEnter={() => onHover(columnKey)}
//           onMouseLeave={() => onHover(null)}
//           style={{
//             flex: 1,
//             overflowY: 'auto',
//             padding: '8px',
//             display: 'flex',
//             flexDirection: 'column',
//             gap: '8px',
//           }}
//         >
//           <SortableContext
//             items={validTasks.map((t) => t.id)}
//             strategy={verticalListSortingStrategy}
//           >
//             {validTasks.map((task) => (
//               <TaskCard
//                 key={task.id}
//                 task={task}
//                 assigneeList={assigneeList}
//                 onOpenModal={onOpenModal}
//                 openOptionModal={handleOpenOptionMenu}
//               />
//             ))}
//             {renderCreate?.(columnKey, hovered === columnKey)}
//           </SortableContext>
//         </div>
//       </Card>
//     </div>
//   );
// };

const DroppableColumn = ({
  columnKey,
  columnId,
  onDeleteColumn,
  tasks,
  taskCount,
  renderCreate,
  hovered,
  onHover,
  assigneeList,
  onOpenModal,
  handleOpenOptionMenu,

  updateHeight,
  getTaskBoardDetails,
  maxHeight,
}) => {
  //console.log(columnKey, columnId, 'columnkey');
  const { setNodeRef } = useDroppable({
    id: columnId,
    data: { type: 'column', columnId },
  });

  const validTasks = Array.isArray(tasks) ? tasks.filter(Boolean) : [];
  const roleId = Number(Cookies.get('task-role-id'));

  return (
    <div
      ref={setNodeRef}
      data-tour="board-column"
      style={{
        flex: 1,
        minWidth: '260px',
        maxWidth: '320px',
        height: maxHeight,
        display: 'flex',
        flexDirection: 'column',
        marginTop: -30,
      }}
    >
      <Card
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: '#fafafa',
        }}
        bodyStyle={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          padding: 0,
        }}
      >
        {/* header */}
        <div
          style={{
            padding: '10px 12px',
            fontWeight: 'bold',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            borderBottom: '1px solid #ddd',
            position: 'sticky',
            top: 0,
            zIndex: 1,
            backgroundColor: 'whitesmoke',
          }}
        >
          <span>
            {columnKey} <span style={{ color: '#666' }}>({taskCount})</span>
          </span>
          {[1, 2].includes(roleId) && !['TO DO', 'DONE'].includes(columnKey) ? (
            <Menu>
              <MenuButton
                as={IconButton}
                icon={<span data-tour="column-menu"><FiMoreHorizontal size={18} /></span>}
                size="sm"
                variant="ghost"
                aria-label="Options"
              />
              <MenuList>
                <MenuItem
                  icon={<DeleteIcon color="red" boxSize={4} />}
                  onClick={() => onDeleteColumn(columnId, columnKey)}
                >
                  Delete
                </MenuItem>
              </MenuList>
            </Menu>
          ) : (
            <IconButton
              icon={<FiMoreHorizontal size={18} />}
              size="sm"
              variant="ghost"
              aria-label="Options"
              style={{ visibility: 'hidden' }}
            />
          )}
        </div>

        {/* Scrollable task list */}
        <div
          onMouseEnter={() => onHover(columnKey)}
          onMouseLeave={() => onHover(null)}
          style={{
            flex: 1,
            overflowY: 'auto',
            padding: '8px',
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
          }}
        >
          <SortableContext
            id={columnId}
            items={validTasks.map((t) => String(t.id ?? t.issue_id))}
            strategy={verticalListSortingStrategy}
          >
            {validTasks.map((task) => (
              <TaskCard
                key={String(task.id ?? task.issue_id)}
                task={task}
                columnId={columnId}
                assigneeList={assigneeList}
                onOpenModal={onOpenModal}
                openOptionModal={handleOpenOptionMenu}
                getTaskBoardDetails={getTaskBoardDetails}
              />
            ))}
            {renderCreate?.(columnKey, hovered === columnKey)}
          </SortableContext>
        </div>
      </Card>
    </div>
  );
};

const DraggableColumnWrapper = ({ id, children }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.7 : 1,
    cursor: 'grab',
    width: '320px', // ✅ fixed width ensures horizontal layout
    flexShrink: 0, // ✅ prevents shrinking (MUST for horizontal scroll)
    height: '100%',
  };

  return (
    <div ref={setNodeRef} {...attributes} {...listeners} style={style}>
      {children}
    </div>
  );
};

const TaskManagementDashboard = ({ isAdminMode, setIsAdminMode }) => {
  // const [tasks, set] = useState({});
  const [isLoading, setisLoading] = useState(false);
  const [addingStatus, setAddingStatus] = useState(false);
  const [newStatusName, setNewStatusName] = useState('');
  const [columnOrder, setColumnOrder] = useState([]);
  const [activeId, setActiveId] = useState(null);
  const [creatingIn, setCreatingIn] = useState(null);
  const [newTitle, setNewTitle] = useState('');
  const [hoveredCol, setHoveredCol] = useState(null);
  const createRef = useRef(null);
  const employeePopoverRef = useRef(null);
  const datePopoverRef = useRef(null);
  const [dueDate, setDueDate] = useState('');
  const [showDatePicker, setShowDatePicker] = useState(false);
  // const[assinedEmployee, setAssignedEmployee]=useState("");
  // const [assignedEmployee, setAssignedEmployee] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [showEmployeePicker, setShowEmployeePicker] = useState(false);
  const [selectedType, setSelectedType] = useState('TASK');
  // const [status, setStatus] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);
  const [optionmodal, setOptionModal] = useState(false);
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [optionMenuData, setOptionMenuData] = useState({
    task: null,
    anchorRef: null,
    isOpen: false,
    trigger: 0,
  });

  const [showsprintmodal, setshowSprintModal] = useState(false);
  const [recentlyCreatedTask, setRecentlyCreatedTask] = useState(null);
  const [epicList, setEpicList] = useState([]);
  const [selectedEpic, setSelectedEpic] = useState(null);
  // const [taskStatusCount, setTaskStatusCount] = useState({});
  const [completesprintModal, setCompletesprintModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredTasks, setFilteredTasks] = useState({});
  const [showdeletestatusmodal, Setdeletestatusmodal] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [sprints, setSprints] = useState([]);
  const [exportdata, setExportdata] = useState(null);
  const [selectedfilterAssignee, setSelectedfilterAssignee] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [subtaskmodal, setSubtaskModal] = useState(false);
  const [selectedSubtask, setSelectedSubtask] = useState(null);
  const [taskType, setTaskType] = useState('task');
  const [selectedTypeId, setSelectedTypeId] = useState(1);

  const ISSUE_TYPE = [
    { id: 1, label: 'Task', value: 'Task', icon: TaskObject },
    { id: 2, label: 'Story', value: 'Story', icon: StoryObject },
    { id: 3, label: 'Bug', value: 'Bug', icon: BugObject },
  ];

  // console.log(ISSUE_TYPE,"issue type")
  const selectedTypeObj = ISSUE_TYPE.find((t) => t.id === selectedTypeId);

  const dispatch = useDispatch();
  const project_id = useParams();
  const dropdownRef = useRef(null);
  const getfilteredata = useSelector(
    (state) => state?.Authentication?.filteredBoard,
  );
  const tasks = useSelector((state) => state?.Authentication?.taskBoardDetails);
 

  const taskStatusCount = useSelector(
    (state) => state?.Authentication?.taskstatuscount,
  );

  const status = useSelector(
    (status) => status?.Authentication?.taskstatuslist,
  );

  const assignedEmployee = useSelector(
    (state) => state?.Authentication?.assigneelist,
  );

  const getfilteredrequestbody = useSelector(
    (state) => state?.Authentication?.filteredrequestbody,
  );

  
 
  const isboardfilterApplied = useSelector(
    (state) => state?.Authentication?.isboardfilterApplied,
  );

  const roleId = Number(Cookies.get('task-role-id'));
  const [maxHeight, setMaxHeight] = useState(700);

  const updateHeight = (height) => {
    setMaxHeight((prev) => Math.max(prev, height));
  };

  const handleOpenOptionMenu = (task, anchorRef) => {
    setOptionMenuData((prev) => ({
      task,
      anchorRef: anchorRef.current,
      isOpen: true,
      trigger: prev.trigger + 1,
    }));
  };

  const handleCloseOptionMenu = () => {
    setOptionMenuData((prevState) => {
      return {
        task: prevState.task,
        anchorRef: prevState.anchorRef,
        isOpen: false,
      };
    });
  };

  useEffect(() => {
    if (!searchQuery) {
      //console.log('No search query, showing all tasks');
      setFilteredTasks(tasks);
      return;
    }

    const query = searchQuery.toLowerCase();
    const newFiltered = {};

    Object.keys(tasks).forEach((col) => {
      newFiltered[col] = tasks[col].filter((t) => {
        const titleMatch = t.title?.toLowerCase().includes(query);
        const keyMatch = t?.task?.task_key?.toLowerCase().includes(query);

        return titleMatch || keyMatch;
      });
    });

    setFilteredTasks(newFiltered);
  }, [searchQuery, tasks]);

  const handleOpenModal = (task) => {
    setSelectedTask(task);
    setModalVisible(true);
  };

  const filterKey = useMemo(() => {
  return JSON.stringify(getfilteredrequestbody);
}, [getfilteredrequestbody]);

  const handleAssigneeClick = (user_id) => {
    setSelectedfilterAssignee((prev) => {
      let updated;
      if (prev.includes(user_id)) {
        updated = prev.filter((id) => id !== user_id);
      } else {
        updated = [...prev, user_id];
      }
 
      return updated;
     
    });
  };

  const isFirstRender = useRef(true);


  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleCloseModal = () => {
    setModalVisible(false);
    setSelectedTask(null);
  };

  const handleOptionModal = (task, anchorRef) => {
    setSelectedTask(task);
    setMenuAnchorEl(anchorRef);
    setOptionModal(true);
  };

  const handleOptionCloseModal = () => {
    setOptionModal(false);
    setSelectedTask(null);
    setMenuAnchorEl(null);
  };

  const handleAddStatus = async () => {
    const reqBody = {
      project_id: project_id.id,
      status_name: newStatusName,
    };

    try {
      const response = await httpInjectorService.addBoardstatus(reqBody);

      if (response.status === 'success') {
        toast.success(response.message, {
          position: 'top-right',
          autoClose: 3000,
        });
        setAddingStatus(false);
        setNewStatusName('');
        listBoardStatus(); // Refresh status columns
      } else {
        toast.error(response.message, {
          position: 'top-right',
          autoClose: 3000,
        });
      }
    } catch (error) {
      console.error('Failed to add new status:', error);
      toast.error('Error adding status');
    }
  };

  const fetchTasksByEpicId = async (epicId) => {
    const queryParams = `?project_id=${project_id.id}&epic_id=${epicId}`;
    try {
      const response =
        await httpInjectorService.gettaskDetailsbyEpicId(queryParams);
      // 🔁 use your epic-specific API
      if (
        response.status === 'success' &&
        Array.isArray(response.data?.tasks)
      ) {
        const grouped = {};

        // Initialize groups by statuses
        status.forEach((s) => {
          grouped[s.status_name] = [];
        });

        response.data?.tasks.forEach((task) => {
          const simplifiedTask = {
            id: task.task_id,
            title: task.task_title,
            assignee_id: task.assignee_id,
            assignee_name: task.assignee_name,
            project_id: task.project_id,
            epic_key: task.epic_key,
            task_status: task.task_status,
            epic_name: task.epic_name,
            task,
          };

          if (grouped[task.task_status]) {
            grouped[task.task_status].push(simplifiedTask);
          }
        });

        // set(grouped);
        dispatch(settaskBoardDetails(grouped));
        if (response.data?.task_status_count) {
          // setTaskStatusCount(response.data.task_status_count);
          dispatch(settaskstatuscount(response.data.task_status_count));
        }
      } else {
        dispatch(settaskstatuscount({}));
        dispatch(settaskBoardDetails({}));
        // set({});
        // setTaskStatusCount({});
      }
    } catch (error) {
      console.error('Failed to fetch tasks by epic:', error);
      // set({});
    }
  };

  const fetchTasksByAssigneeId = async (epicId) => {
    const queryParams = `?project_id=${project_id.id}&epic_id=${epicId}`;
    try {
      const response =
        await httpInjectorService.gettaskDetailsbyEpicId(queryParams);
      // 🔁 use your epic-specific API
      if (
        response.status === 'success' &&
        Array.isArray(response.data?.tasks)
      ) {
        const grouped = {};

        // Initialize groups by statuses
        status.forEach((s) => {
          grouped[s.status_name] = [];
        });

        response.data?.tasks.forEach((task) => {
          const simplifiedTask = {
            id: task.task_id,
            title: task.task_title,
            assignee_id: task.assignee_id,
            assignee_name: task.assignee_name,
            project_id: task.project_id,
            epic_key: task.epic_key,
            task_status: task.task_status,
            task,
          };

          if (grouped[task.task_status]) {
            grouped[task.task_status].push(simplifiedTask);
          }
        });

        // set(grouped);
        dispatch(settaskBoardDetails(grouped));
        if (response.data?.task_status_count) {
          // setTaskStatusCount(response.data.task_status_count);
          dispatch(settaskstatuscount(response.data.task_status_count));
        }
      } else {
        dispatch(settaskstatuscount({}));
        dispatch(settaskBoardDetails({}));
        // set({});
        // setTaskStatusCount({});
      }
    } catch (error) {
      console.error('Failed to fetch tasks by epic:', error);
      // set({});
    }
  };


  const isFilterBodyEmpty = (body) => {
  if (!body) return true;

  return (
    (!body.assignee_id || body.assignee_id.length === 0) &&
    (!body.epic_id || body.epic_id.length === 0) &&
    (!body.labels_id || body.labels_id.length === 0) &&
    (!body.sprint_id || body.sprint_id.length === 0) &&
    (!body.issue_type_id || body.issue_type_id.length === 0) &&
    (!body.issue_status || body.issue_status.length === 0)
  );
};




  // const getTaskBoardDetails = async () => {
  //   try {
  //     const finalRequestBody = isFilterBodyEmpty(getfilteredrequestbody)
  //     ? { project_id: project_id.id }
  //     : getfilteredrequestbody;
  //     console.log(finalRequestBody, "finalRequestBody")
  //     const response = await httpInjectorService.filteringBoardPage(finalRequestBody);
  //     console.log(response, 'responsegettask')
  //     if (
  //       response.status === 'success' &&
  //       Array.isArray(response.data?.tasks)
  //     ) {
  //       const grouped = {};

  //       // Initialize grouped with current statuses
  //       status?.forEach((s) => {
  //         grouped[s.status_name] = [];
  //       });

  //       response.data?.tasks.forEach((task) => {
  //         const simplifiedTask = {
  //           id: task.issue_id,
  //           issue_type_id: task.issue_type_id,
  //           issue_type: task.issue_type,
  //           title: task.issue_title,
  //           assignee_id: task.assignee_id,
  //           assignee_name: task.assignee_name,
  //           project_id: task.project_id,
  //           epic_key: task.epic_key,
  //           task_status: task.issue_status,
  //           epic_name: task.epic_name,
  //           subtasks_count: {
  //             total: task.subtask_count?.total ?? 0,
  //             done: task.subtask_count?.done ?? 0,
  //           },
  //           task,
  //         };

  //         if (grouped[task.issue_status]) {
  //           grouped[task.issue_status].push(simplifiedTask);
  //         } else {
  //           console.warn('Unmapped task status:', task.task_status);
  //         }
  //       });

  //       // set(grouped);
  //       dispatch(settaskBoardDetails(grouped));

  //       if (response.data?.task_status_count) {
  //         dispatch(settaskstatuscount(response.data.task_status_count));
  //       }
  //     } else {
  //       // set({});
  //       //   dispatch(settaskBoardDetails({}))
  //       //  dispatch(settaskstatuscount({}))
  //       dispatch(settaskBoardDetails({}));
  //       dispatch(settaskstatuscount({}));
  //     }
  //   } catch (error) {
  //     console.error('Failed to fetch task board details:', error);
  //     // set({});
  //   }
  // };


  const getTaskBoardDetails = async () => {
  try {
    if (!status || status.length === 0) {
     
      return;
    }
    const finalRequestBody = isFilterBodyEmpty(getfilteredrequestbody)
      ? { project_id: project_id.id }
      : getfilteredrequestbody;
    
    const response = await httpInjectorService.filteringBoardPage(finalRequestBody);
   

    if (response.status === 'success') {
      const grouped = {};
      status?.forEach((s) => {
        grouped[s.status_name.toUpperCase()] = [];
      });

      let tasks = [];
      if (Array.isArray(response.data?.tasks)) {
        tasks = response.data.tasks.map((task) => ({
          ...task,
          epic_name: task.epic_name,
          epic_key: task.epic_key,
        }));
      }

      // Case B → Epics with tasks
      else if (Array.isArray(response.data?.epics)) {
        response.data.epics.forEach((epic) => {
          (epic.tasks || []).forEach((task) => {
            tasks.push({
              ...task,
              epic_name: epic.epic_name,
              epic_key: epic.epic_key,
            });
          });
        });
      }

      // 3️⃣ Group tasks by status
      tasks.forEach((task) => {
        const simplifiedTask = {
          id: task.issue_id,
          issue_type_id: task.issue_type_id,
          issue_type: task.issue_type,
          title: task.issue_title,
          assignee_id: task.assignee_id,
          assignee_name: task.assignee_name,
          project_id: task.project_id,
          epic_key: task.epic_key,
          epic_name: task.epic_name,
          task_status: task.issue_status,
          subtasks_count: {
            total: task.subtask_count?.total ?? 0,
            done: task.subtask_count?.done ?? 0,
          },
          task,
        };

        const key = task.issue_status?.toUpperCase();

        if (grouped[key]) {
          grouped[key].push(simplifiedTask);
        } else {
          console.warn('Unmapped task status:', key);
        }
      });
    
      dispatch(settaskBoardDetails(grouped));

      if (response.data?.issue_status_count) {
        dispatch(settaskstatuscount(response.data.issue_status_count));
      }
    } else {
       toast.error(response.message, {
          position: 'top-right',
          autoClose: 3000,
        });
    
      dispatch(settaskBoardDetails({}));
      dispatch(settaskstatuscount({}));
      
    }
  } catch (error) {
    
     dispatch(settaskBoardDetails({}));
      dispatch(settaskstatuscount({}));
      
    console.error('Failed to fetch task board details:', error);
  }
};

  const listBoardStatus = async () => {
    // setisLoading(true);
    try {
      const response = await httpInjectorService.ListBoardStatus(project_id.id);
      if (response.status === 'success' && Array.isArray(response.data)) {
        const statusList = response?.data;
        dispatch(setTaskstatuslist(statusList));
        // setStatus(statusList);
        // setColumnOrder(statusList?.map((s) => s.status_name)); // 👈 track order separately

        // Initialize empty task arrays dynamically
        const initialTasks = {};
        statusList?.forEach((s) => {
          initialTasks[s.status_name] = [];
        });
        // dispatch(settaskBoardDetails(initialTasks));
        // setisLoading(false);
      } else {
        // setStatus([]);
        dispatch(setTaskstatuslist([]));
        // setisLoading(false);
        // set({});
      }
    } catch (error) {
      console.error('Failed to fetch board statuses', error);
    }
  };

  const handleClearAllAssignee = () => {
    setSelectedfilterAssignee([]); 
  };

  const handleClear = () => {
    setSelectedfilterAssignee([]);
    // getTaskBoardDetails();
    
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      const clickedOutsideCard =
        createRef.current && !createRef.current.contains(event.target);
      const clickedOutsideEmployeePopover =
        employeePopoverRef.current &&
        !employeePopoverRef.current.contains(event.target);
      const clickedOutsideDatePopover =
        datePopoverRef.current &&
        !datePopoverRef.current.contains(event.target);

      if (
        clickedOutsideCard &&
        clickedOutsideEmployeePopover &&
        clickedOutsideDatePopover
      ) {
        setCreatingIn(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [createRef, employeePopoverRef, datePopoverRef]);

  const sensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 1 } }),
  );

  // const onDragStart = ({ active }) => {
  //   console.log(active, "activeId")
  //   const activeIdValue = active.id;

  //   if (columnOrder.includes(activeIdValue)) {
  //     if (![1, 2].includes(roleId)) {
  //       setActiveId(null);
  //       return;
  //     }
  //   }

  //   if (findColumn(tasks, activeIdValue)) {
  //     if (![1, 2, 3].includes(roleId)) {
  //       setActiveId(null);
  //       return;
  //     }
  //   }

  //   // ✅ Allowed → set active
  //   setActiveId(active.id);
  // };

  //   const onDragEnd = async ({ active, over }) => {
  //     console.log(active, "activeee", over, "overrr")
  //   setActiveId(null);
  //   if (!over || active.id === over.id) return;

  //   const activeIdValue = active.id; // task ID or column ID
  //   let dstColumnId;

  //   // Determine destination column
  //   if (over.data?.current?.type === 'column') {
  //     dstColumnId = over.data.current.columnId; // dropped on empty column
  //   } else if (over.data?.current?.type === 'task') {
  //     dstColumnId = findColumn(tasks, over.id); // dropped on task
  //   } else {
  //     return; // invalid drop
  //   }

  //   // Column sorting (roles 1 & 2)
  //   if ([1, 2].includes(roleId) && columnOrder.includes(activeIdValue) && columnOrder.includes(over.id)) {
  //     const oldIndex = columnOrder.indexOf(activeIdValue);
  //     const newIndex = columnOrder.indexOf(over.id);
  //     const updated = [...columnOrder];
  //     updated.splice(oldIndex, 1);
  //     updated.splice(newIndex, 0, activeIdValue);
  //     setColumnOrder(updated);

  //     const status_orders = updated.map((colId, index) => ({ id: colId, order: index + 1 }));
  //     try {
  //       await httpInjectorService.updateBoardStatusorder({ project_id: project_id.id, status_orders });
  //     } catch (err) {
  //       console.error('Status order update failed', err);
  //     }
  //     return;
  //   }

  //   // Task move/reorder (roles 1,2,3)
  //   if ([1,2,3].includes(roleId)) {
  //     const srcColumnId = findColumn(tasks, activeIdValue);
  //     if (!srcColumnId || !dstColumnId) return;

  //     const sourceTasks = [...tasks[srcColumnId]];
  //     const taskIndex = sourceTasks.findIndex((t) => t.id === activeIdValue);
  //     if (taskIndex === -1) return;

  //     const [task] = sourceTasks.splice(taskIndex, 1);
  //     const destTasks = srcColumnId === dstColumnId ? [...sourceTasks] : [...tasks[dstColumnId]];

  //     if (srcColumnId === dstColumnId) {
  //       // reorder inside same column
  //       const overIndex = destTasks.findIndex((t) => t.id === over.id);
  //       if (overIndex !== -1) destTasks.splice(overIndex, 0, task);
  //       else destTasks.push(task);
  //     } else {
  //       // move across columns
  //       task.status = dstColumnId;
  //       destTasks.push(task);
  //     }

  //     const updatedTasks = { ...tasks, [srcColumnId]: sourceTasks, [dstColumnId]: destTasks };
  //     dispatch(settaskBoardDetails(updatedTasks));

  //     try {
  //       await httpInjectorService.taskUpdateStatus({
  //         project_id: task.project_id,
  //         task_id: task.id,
  //         task_status: dstColumnId, // send column ID
  //       });
  //       getTaskBoardDetails();
  //     } catch (err) {
  //       console.error('Task status update failed:', err);
  //       toast.error('Error updating task status');
  //     }
  //   }
  // };

  //  const onDragEnd = async ({ active, over }) => {
  //   if (!over) return;

  //   const activeTaskId = active.id;

  //   const srcColumnId = active.data.current.columnId;
  //   console.log(srcColumnId, "sourceID") // from useSortable
  //   const destColumnId = over.id;
  //   console.log(destColumnId, "destcolll")                     // from useDroppable

  //   if (srcColumnId === destColumnId) return;

  //   // Find destination status object
  //   const destStatusObj = status.find(
  //     (s) => s.id === destColumnId
  //   );
  //   console.log(destStatusObj, "deststtausobj")

  //   if (!destStatusObj) {
  //     console.error("Invalid destination column:", destColumnId);
  //     return;
  //   }

  //   const newStatusName = destStatusObj.status_name;
  //   console.log(newStatusName, 'newstatusNmae')

  //   // Remove task from source
  //   const sourceTasks = [...tasks[srcColumnId]];
  //   const taskIndex = sourceTasks.findIndex((t) => t.id === activeTaskId);
  //   const [task] = sourceTasks.splice(taskIndex, 1);

  //   // Add to destination
  //   const destTasks = [...(tasks[destColumnId] || [])];
  //   task.status_name = newStatusName;  // update task status
  //   destTasks.push(task);

  //   // Update UI
  //   const updated = {
  //     ...tasks,
  //     [srcColumnId]: sourceTasks,
  //     [destColumnId]: destTasks,
  //   };

  //   dispatch(settaskBoardDetails(updated));

  //   // Backend update
  //   try {
  //     await httpInjectorService.taskUpdateStatus({
  //       project_id: task.project_id,
  //       task_id: task.id,
  //       task_status: newStatusName,     // send correct status name
  //     });

  //   } catch (err) {
  //     console.error("Failed to update status:", err);
  //   }
  // };

  const onDragStart = ({ active }) => {
    //console.log(active, 'actibvee');
    const { type } = active.data.current || {};

    // ---- COLUMN DRAG ----
    if (type === 'column') {
      if (![1, 2].includes(roleId)) return;
      setActiveId(active.id);
      return;
    }

    // ---- TASK DRAG ----
    if (type === 'task') {
      if (![1, 2, 3].includes(roleId)) return;
      setActiveId(active.id);
    }
  };

  const onDragEnd = async ({ active, over }) => {
    if (!over) return;

    const activeId = active.id;
    const overId = over.id;

    if (
      [1, 2].includes(roleId) &&
      columnOrder.includes(activeId) &&
      columnOrder.includes(overId)
    ) {
      const oldIndex = columnOrder.indexOf(activeId);
      const newIndex = columnOrder.indexOf(overId);

      if (oldIndex !== -1 && newIndex !== -1) {
        const updated = [...columnOrder];
        updated.splice(oldIndex, 1);
        updated.splice(newIndex, 0, activeId);

        setColumnOrder(updated);

        const status_orders = updated
          .map((columnId, index) => {
            const match = status?.find((s) => s.id === columnId);
            return match ? { id: match.id, order: index + 1 } : null;
          })
          .filter(Boolean);

        try {
          const payload = {
            project_id: project_id.id,
            status_orders,
          };
          const response =
            await httpInjectorService.updateBoardStatusorder(payload);
        } catch (err) {
          console.error(' Error updating status order:', err);
        }
      }
      return; // column handled
    }

    // --- TASK DRAG LOGIC ---
    // --- TASK DRAG LOGIC ---
    if (active.data?.current?.type === 'task') {
      const srcColumnId = active.data.current.columnId;

      // Determine destination column and index
      let destColumnId;
      let destIndex = 0;

      if (over.data?.current?.type === 'task') {
        destColumnId = over.data.current.columnId;
        destIndex = over.data.current.sortable.index;
      } else {
        destColumnId = over.id;

        const destStatusObj = status.find((s) => s.id === destColumnId);
        if (!destStatusObj) return;

        const destKey = destStatusObj.status_name;
        destIndex = tasks[destKey]?.length ?? 0;
      }

      const srcStatusObj = status.find((s) => s.id === srcColumnId);
      const destStatusObj = status.find((s) => s.id === destColumnId);
      if (!srcStatusObj || !destStatusObj) return;

      const srcKey = srcStatusObj.status_name;
      const destKey = destStatusObj.status_name;

      if (!tasks[srcKey]) return;

      // --- SAME COLUMN REORDER ---
      if (srcKey === destKey) {
        const columnTasks = [...tasks[srcKey]];
        const oldIndex = columnTasks.findIndex((t) => t.id === active.id);
        if (oldIndex === -1) return;

        const [task] = columnTasks.splice(oldIndex, 1);
        columnTasks.splice(destIndex, 0, task);

        const updated = { ...tasks, [srcKey]: columnTasks };
        dispatch(settaskBoardDetails(updated));
        return;
      }

      // --- MOVE TO DIFFERENT COLUMN ---
      const sourceTasks = [...tasks[srcKey]];
      const destTasks = [...(tasks[destKey] ?? [])];

      const taskIndex = sourceTasks.findIndex((t) => t.id === active.id);
      if (taskIndex === -1) return;

      const [task] = sourceTasks.splice(taskIndex, 1);
      task.status_name = destKey;

      destTasks.splice(destIndex, 0, task);

      const updated = {
        ...tasks,
        [srcKey]: sourceTasks,
        [destKey]: destTasks,
      };

      dispatch(settaskBoardDetails(updated));

      try {
        await httpInjectorService.taskUpdateStatus({
          project_id: task.project_id,
          issue_id: task.id,
          issue_type_id:task.issue_type_id,
          issue_status: destKey,
        });
        getTaskBoardDetails();
      } catch (err) {
        console.error('Task API update failed:', err);
      }
    }
  };

  const handleopensubtaskmodal = (task) => {
    setSelectedSubtask(task);
    setSubtaskModal(true);
    setModalVisible(false);
  };

  const handleclosesubtaskmodal = () => {
    setSubtaskModal(false);
  };

  const handleDateChange = (e) => {
    setDueDate(e.target.value);
    setShowDatePicker(false);
  };

  const createTask = async (col, title) => {
    //console.log(title, 'titlee');
    const trimmedTitle = title.trim();
    const tempId = Date.now();

    const tempTask = {
      id: tempId,
      title: trimmedTitle,
      status: col,
      assignee_id: selectedEmployee?.user_id ?? null,
      assignee_name: selectedEmployee?.username ?? null,
    };

    // const tempTask = { id: tempId, title: newTitle, status: col };
    //     set({
    //   ...tasks,
    //   [col]: [...(tasks[col] || []), tempTask]
    // });
    dispatch(
      settaskBoardDetails({
        ...tasks,
        [col]: [...(tasks[col] || []), tempTask],
      }),
    );

    setCreatingIn(null);
    setNewTitle('');
    setSelectedEmployee(null);
    titleRef.current = '';

    const payload = {
      project_id: project_id.id,
      issue_title: trimmedTitle,
      issue_type_id: selectedTypeId,
      issue_type: selectedType,
      issue_status: col,
      due_date: dueDate || null,
      assignee_id: selectedEmployee?.user_id || null,
    };

    try {
      const response = await httpInjectorService.AddTaskWithoutEpic(payload);
      if (response.status === 'success') {
        // set((prev) => ({
        //   ...prev,
        //   [col]: prev[col]?.map((t) => (t.id === tempId ? response.data : t)),
        // }));
        setSelectedEmployee(null);
        setDueDate('');
        getTaskBoardDetails();
        setRecentlyCreatedTask(response.data);
        toast.success(response.message, {
          position: 'top-right',
          autoClose: 3000,
        });
        setshowSprintModal(true);
      } else {
        toast.error(response.message, {
          position: 'top-right',
          autoClose: 3000,
        });
      }
    } catch (error) {
      console.error('Failed to create task:', error);
    }
  };

  const getprojectAssignedEmployee = async () => {
    try {
      let response = await httpInjectorService.getProjectAssignedEmployeelist(
        project_id.id,
      );
      if (response.status === 'success') {
        // setAssignedEmployee(response.data);
        dispatch(setassigneelist(response.data));
      } else {
        dispatch(setassigneelist([]));
      }
    } catch (error) {
      console.error('Failed to fetch employee', error);
    }
  };

  const handleDeleteColumn = async (statusId, colKey) => {
    if (!statusId) return;
    const taskIds = (tasks[colKey] || []).map((task) => task.id);

    try {
      const reqBody = {
        project_id: project_id.id,
        status_name: colKey,
        status_id: statusId,
        task_ids: [...taskIds],
      };

      const response = await httpInjectorService.delete_status_column(reqBody);

      if (response.status === 'success') {
        listBoardStatus();
      } else {
        console.error('Failed to delete status:', response.message);
      }
    } catch (error) {
      console.error('Error deleting status:', error);
    }
  };

  const openDeleteModal = (statusId, colKey) => {
    setSelectedStatus({ id: statusId, colKey });
    Setdeletestatusmodal(true);
  };

  const getEpiclist = async () => {
    const queryParams = `?project_id=${project_id.id}`;
    // const projectId=project_id.id
    try {
      const response = await httpInjectorService.get_epic(queryParams);
      if (response.status === 'success') {
        setEpicList(response.data);
      }
    } catch (error) {
      console.error('Failed to fetch epics:', error);
    }
  };

  useEffect(() => {
    listBoardStatus();
    getEpiclist();
    getprojectAssignedEmployee();
    getsprintlist();
   
    // handleExport();
  }, []);



useEffect(() => {
  // skip first page load
  if (isFirstRender.current) {
    isFirstRender.current = false;
    return;
  }

  // skip empty filter
  if (Object.keys(filterKey || {}).length === 0) return;



  getTaskBoardDetails();

 
}, [filterKey]);

  const stripHtmlexportdata = (html) => {
  if (!html) return '';

  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = html;
  return tempDiv.textContent
    ?.replace(/\u00A0/g, ' ') 
    ?.trim() || '';
};


  const handleExport = async () => {
    let reqbody = { project_id: project_id.id };

    try {
      const response = await httpInjectorService.exportTaskData(reqbody);

      if (response.status === 'success') {
        const { project, epics, tasks, subtasks } = response.data;

        // Merge all into one array with type
        const allData = [
  ...epics.map((i) => ({
    ...i,
    type: 'Epic',
    project: project.name,
    description:stripHtmlexportdata (i.epic_description),
    assignee: i.assignee || '',
  })),

  ...tasks.map((i) => ({
    ...i,
    type: 'Task',
    project: project.name,
    description:stripHtmlexportdata(i.issue_description),
    assignee: i.assignee || '',
  })),

  ...subtasks?.map((i) => ({
    ...i,
    type: 'Subtask',
    project: project.name,
    description: stripHtmlexportdata(i.subtask_description),
    assignee: i.assignee || '',
  })),
];
        // Create workbook & sheet
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Exported Data');

      
        worksheet.columns = [
          { header: 'Project', key: 'project', width: 20 },
          { header: 'Key', key: 'key', width: 15 },
          { header: 'Type', key: 'type', width: 12 },
          { header: 'Parent', key: 'parent', width: 15 },
          { header: 'Summary', key: 'summary', width: 40 },
          { header: 'Status', key: 'status', width: 15 },
          { header: 'Assignee', key: 'assignee', width: 20 },
          { header: 'Sprint', key: 'sprint', width: 20 },
          { header: 'Start Date', key: 'startDate', width: 15 },
          { header: 'Due Date', key: 'dueDate', width: 15 },
        ];

        allData.forEach((row) => worksheet.addRow(row));

        worksheet.getRow(1).eachCell((cell) => {
          cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FF4472C4' },
          };
        });

        const buffer = await workbook.xlsx.writeBuffer();
        const fileName = `${project.key}_export.xlsx`;
        saveAs(new Blob([buffer]), fileName);
      }
    } catch (error) {
      console.error('Failed to export:', error);
    }
  };

  // const handleExport=async()=>{
  //   let reqbody={
  //     project_id:project_id.id
  //   }
  //   try{
  //   const response=await httpInjectorService.exportTaskData(reqbody);
  //   if(response.status==="success"){
  //     setExportdata(response.data)
  //   }else{
  //     setExportdata({})
  //   }}catch(error){
  //      console.error('Failed to fetch epics:', error);
  //   }

  // }

  // useEffect(() => {
  //     const fetchData = async () => {
  //       if (status.length > 0) {
  //         setisLoading(true);
  
  //         setColumnOrder(status.map((s) => s.id));
  
  //         await getTaskBoardDetails();
  
  //         // await getEpiclist();
  
  //         setisLoading(false);
  //       }
  //     };
  
  //     fetchData();
  //   }, [status])
  useEffect(() => {
  if (status.length > 0) {
    setColumnOrder(status.map((s) => s.id));
  }
}, [status]);

const hasCalledApi = useRef(false);

useEffect(() => {
  const fetchData = async () => {
   

    if (!status || status.length === 0) return;

    // prevent duplicate calls
    if (hasCalledApi.current) return;

    hasCalledApi.current = true;

    try {
      setisLoading(true);

     

      await getTaskBoardDetails();
    } catch (error) {
      console.log(error);
    } finally {
      setisLoading(false);
    }
  };

  fetchData();
}, [status]);

  const handleCompleteSprint = () => {
    setCompletesprintModal(true);
  };

  const getsprintlist = async () => {
    try {
      const response = await httpInjectorService.getsprintList(project_id.id);
      if (response.status === 'success') {
        const activeSprints = response.data?.active_sprints || [];
        setSprints(activeSprints); // 👈 only active sprints
      } else {
        toast({
          title: 'Error',
          description: response.message || 'Failed to fetch sprint list.',
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error('Error fetching sprint list:', error);
      toast({
        title: 'Error',
        description: 'Something went wrong while fetching sprints.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  // const applyFilter = async () => {
  //   try {
  //     const response = await httpInjectorService.filteringBoardPage(
  //       getfilteredrequestbody,
  //     );

  //     if (
  //       response.status === 'success' &&
  //       Array.isArray(response.data?.epics)
  //     ) {
  //       toast.success(response.message, {
  //         position: 'top-right',
  //         autoClose: 3000,
  //       });

  //       const grouped = {};

  //       // Initialize empty arrays for each status
  //       status?.forEach((s) => {
  //         grouped[s.status_name] = [];
  //       });

  //       // Flatten and group tasks from all epics
  //       response.data.epics.forEach((epic) => {
  //         if (Array.isArray(epic.tasks)) {
  //           epic.tasks.forEach((task) => {
  //             const simplifiedTask = {
  //               id: task.task_id,
  //               title: task.task_title,
  //               assignee_id: task.assignee_id,
  //               assignee_name: task.assignee_name,
  //               project_id: task.project_id,
  //               epic_key: task.epic_key,
  //               epic_name: task.epic_name,
  //               task_status: task.task_status,
  //               task,
  //             };

  //             if (grouped[task.task_status]) {
  //               grouped[task.task_status].push(simplifiedTask);
  //             }
  //           });
  //         }
  //       });

  //       // Update state & redux

  //       dispatch(settaskBoardDetails(grouped));

  //       // Map status summary to an object like { "QA": 2, "TO DO": 1, ... }
  //       if (Array.isArray(response.data.status_summary)) {
  //         const statusCountObj = {};
  //         response.data.status_summary.forEach((item) => {
  //           statusCountObj[item.task_status] = item.status_count;
  //         });
  //         // setTaskStatusCount(statusCountObj);
  //         dispatch(settaskstatuscount(statusCountObj));
  //       }
  //     } else {
  //       toast.error(response.message, {
  //         position: 'top-right',
  //         autoClose: 3000,
  //       });
  //       // Handle empty results
  //       dispatch(settaskBoardDetails({}));
  //       await getTaskBoardDetails();

  //       dispatch(settaskstatuscount({}));
  //     }
  //   } catch (error) {}
  // };

  const MAX_VISIBLE = 4;
  const visible = assignedEmployee.slice(0, MAX_VISIBLE);
  const hidden = assignedEmployee.slice(MAX_VISIBLE);
  const titleRef = useRef('');

  const renderCreate = (col, isHovered) => {
    if (creatingIn === col) {
      return (
        <div
          ref={createRef}
          style={{
            marginBottom: 16,
            position: 'relative',
            border: '1px solid #3399ff',
            padding: 8,
            background: '#fff',
            overflow: 'visible',
          }}
          data-tour="create-task"
        >
          <div style={{ position: 'relative' }}>
            <textarea
              autoFocus
              defaultValue={titleRef.current}
              placeholder="What's need to be done?"
              style={{
                width: '100%',
                height: 120,
                border: 'none',
                outline: 'none',
                resize: 'none',
                paddingBottom: 40,
                boxSizing: 'border-box',
                fontSize: 14,
              }}
              onInput={(e) => {
                titleRef.current = e.target.value;
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter' && !e.shiftKey) {
                  e.preventDefault();
                  createTask(col, titleRef.current);
                  titleRef.current = '';
                }
              }}
            />

            <Box position="absolute" bottom="8px" left="3px" zIndex={10}>
              <Select
                size="small"
                value={selectedTypeId}
                onChange={(value) => {
                  setSelectedTypeId(value);
                  const typeObj = ISSUE_TYPE.find((t) => t.id === value);
                  setSelectedType(typeObj?.label || '');
                }}
                style={{ width: 60 }}
                optionLabelProp="label"
                popupMatchSelectWidth={false}
                getPopupContainer={(triggerNode) => triggerNode.parentElement}
              >
                {ISSUE_TYPE.map(({ id, label, icon: Icon }) => (
                  <Select.Option
                    key={id}
                    value={id}
                    label={Icon ? <Icon width={20} /> : label}
                  >
                    <div
                      style={{ display: 'flex', alignItems: 'center', gap: 8 }}
                    >
                      {Icon && <Icon width={20} />}
                      <span>{label}</span>
                    </div>
                  </Select.Option>
                ))}
              </Select>
            </Box>

            <Box
              position="absolute"
              bottom="8px"
              right="8px"
              display="flex"
              alignItems="center"
              gap={2}
              zIndex={10}
            >
              <Popover
                isOpen={showEmployeePicker}
                onClose={() => setShowEmployeePicker(false)}
              >
                <PopoverTrigger>
                  <span
                    onClick={() => setShowEmployeePicker(!showEmployeePicker)}
                    style={{ cursor: 'pointer' }}
                  >
                    {selectedEmployee?.username ? (
                      <UserAvatar
                        username={selectedEmployee.username}
                        size={24}
                      />
                    ) : (
                      <MdOutlinePerson size={20} />
                    )}
                  </span>
                </PopoverTrigger>

                <Portal>
                  <PopoverContent ref={employeePopoverRef}>
                    <PopoverBody>
                      {assignedEmployee?.length > 0 ? (
                        <Box
                          maxH="200px"
                          overflowY="auto"
                          className="hide-scrollbar"
                        >
                          {assignedEmployee?.map((emp) => (
                            <Flex
                              key={emp.user_id}
                              align="center"
                              p="6px 10px"
                              borderRadius="6px"
                              cursor="pointer"
                              bg={
                                selectedEmployee?.user_id === emp.user_id
                                  ? '#e6f4ff'
                                  : 'transparent'
                              }
                              _hover={{ background: '#f0f0f0' }}
                              onClick={() => {
                                setSelectedEmployee(emp);
                                setShowEmployeePicker(false);
                              }}
                            >
                              <Box w="24px" h="24px" mr="8px">
                                <UserAvatar username={emp.username} size={24} />
                              </Box>
                              <Box fontSize="14px" color="#333">
                                {emp.username}
                              </Box>
                            </Flex>
                          ))}
                        </Box>
                      ) : (
                        <Box fontSize="12px" color="#888">
                          No employees found
                        </Box>
                      )}
                    </PopoverBody>
                  </PopoverContent>
                </Portal>
              </Popover>

              <Popover
                isOpen={showDatePicker}
                onClose={() => setShowDatePicker(false)}
              >
                <PopoverTrigger>
                  <span onClick={() => setShowDatePicker(!showDatePicker)}>
                    <MdOutlineCalendarToday
                      size={20}
                      style={{ cursor: 'pointer' }}
                    />
                  </span>
                </PopoverTrigger>

                <Portal>
                  <PopoverContent width="auto" ref={datePopoverRef}>
                    <PopoverBody>
                      <Input
                        type="date"
                        value={dueDate}
                        onChange={handleDateChange}
                        size="sm"
                      />
                    </PopoverBody>
                  </PopoverContent>
                </Portal>
              </Popover>

              {/* Create Button */}
              {/* <Button
                bg="#722ED1"
                color="white"
                size="xs"
                _hover={{ bg: '#5a1fb3' }}
                onClick={() => createTask(col)}
              >
                Create
              </Button> */}

              <Button
                bg="#722ED1"
                color="white"
                size="xs"
                _hover={{ bg: '#5a1fb3' }}
                onClick={() => createTask(col, titleRef.current)}
              >
                Create
              </Button>
            </Box>
          </div>
        </div>
      );
    }

    if (isHovered) {
      return (
        <div style={{ textAlign: 'center', marginBottom: 16 }}>
          {[1, 2, 3].includes(roleId) && (
            <Button
              size="sm"
              variant="outline"
              leftIcon={<AddIcon />}
              onClick={() => setCreatingIn(col)}
              data-tour="create-task"
            >
              Create
            </Button>
          )}
        </div>
      );
    }

    return null;
  };

  const hasTasks = Object.values(tasks).some((col) => col.length > 0);

  return (
    <Card
      style={{
        position: 'fixed',
        top: '170px',
        left: '50px',
        right: 0,
        bottom: 0,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      {/* 🔒 Fixed Header */}

      <div
         style={{
    marginBottom: 14,
    marginTop: '10px',
    marginLeft: '30px',
    marginRight: '30px',
    display: 'flex',
    justifyContent: 'space-between', // 👈 important
    alignItems: 'center',
  }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          {/* Left group - no space between first three columns */}

          <Input
            placeholder="Search Board"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            allowClear
            prefix={<SearchIcon color="gray.400" />}
            data-tour="board-search"
          ></Input>

          <Space style={{ position: 'relative', display: 'flex' }}>
            {visible.map((a, index) => {
              const isSelected = selectedfilterAssignee.includes(a.user_id);
              return (
                <Tooltip key={a.user_id} title={a.username}>
                  <div
                    onClick={() => handleAssigneeClick(a.user_id)}
                    style={{
                      border: isSelected
                        ? '2px solid #1677ff'
                        : '2px solid white',
                      borderRadius: '50%',
                      boxShadow: isSelected
                        ? '0 0 5px rgba(22,119,255,0.4)'
                        : 'none',
                      marginLeft: index === 0 ? 0 : -8,
                      cursor: 'pointer',
                      transition: '0.2s',
                      background: '#fff',
                    }}
                  >
                    <UserAvatar username={a.username} size={32} />
                  </div>
                </Tooltip>
              );
            })}

            {hidden.length > 0 && (
              <div
                ref={dropdownRef}
                style={{
                  position: 'relative',
                  display: 'inline-block',
                }}
              >
                <div
                  style={{
                    width: 32,
                    height: 32,
                    borderRadius: '50%',
                    background: '#f5f5f5',
                    color: '#555',
                    fontSize: 13,
                    fontWeight: 500,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginLeft: -8,
                    cursor: 'pointer',
                    border: '2px solid white',
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setDropdownOpen((prev) => !prev);
                  }}
                >
                  +{hidden.length}
                </div>

                {/* Custom popup menu */}
                {dropdownOpen && (
                  <div
                    style={{
                      position: 'absolute',
                      top: 40,
                      right: 0,
                      width: 220,
                      maxHeight: 300,
                      overflowY: 'auto',
                      background: '#fff',
                      border: '1px solid #f0f0f0',
                      borderRadius: 8,
                      padding: 8,
                      boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                      zIndex: 9999,
                    }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    {hidden.map((a) => {
                      const isSelected = selectedfilterAssignee.includes(
                        a.user_id,
                      );
                      return (
                        <div
                          key={a.user_id}
                          onClick={() => handleAssigneeClick(a.user_id)}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 8,
                            padding: '8px',
                            borderRadius: 6,
                            background: isSelected
                              ? 'rgba(22,119,255,0.08)'
                              : 'transparent',
                            cursor: 'pointer',
                            marginBottom: 6,
                          }}
                        >
                          <UserAvatar username={a.username} size={24} />
                          <span style={{ flex: 1, fontSize: 13 }}>
                            {a.username}
                          </span>
                          {isSelected && (
                            <span
                              style={{
                                color: '#1677ff',
                                fontWeight: 700,
                              }}
                            >
                              ✓
                            </span>
                          )}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            )}
          </Space>
          {selectedfilterAssignee.length > 0 && (
            <span
              onClick={handleClear}
              style={{
                cursor: 'pointer',
                color: '#1677ff',
                fontSize: 13,
                marginLeft: 8,
                textDecoration: 'underline',
              }}
            >
              Clear
            </span>
          )}
          
          <div data-tour="board-filter">
          <FilterDropdownPanel
            status={status}
            getTaskBoards={getTaskBoardDetails}
            selectedfilterAssignee={selectedfilterAssignee}
            onAssigneeChange={setSelectedfilterAssignee}
            onClearAll={handleClear}
          />
          </div>
        </div>

        {/* Right - Complete Sprint button */}
        {/* Right - Complete Sprint button */}

        {/* <div style={{ display: 'flex', gap: 8 }}>
          {hasTasks && [1, 2].includes(roleId) && (
            <Col>
              <Button
                onClick={handleCompleteSprint}
                bg="#722ED1"
                color="white"
                size="sm"
                _hover={{ bg: 'hsl(264, 71%, 41%)' }}
              >
                Complete Sprint
              </Button>
            </Col>
          )}

          {[1, 2, 3].includes(roleId) && (
            <Button
              onClick={handleExport}
              bg="#722ED1"
              color="white"
              size="sm"
              _hover={{ bg: '#5a1fb3' }}
            >
              Export
            </Button>
          )}
        </div> */}
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          {hasTasks && [1, 2].includes(roleId) && (
            <Col>
              <Button
                onClick={handleCompleteSprint}
                bg="#722ED1"
                color="white"
                size="sm"
                _hover={{ bg: '#5a1fb3' }}
              >
                Complete Sprint
              </Button>
            </Col>
          )}
           <div data-tour="sprint-check">
          <SprintPopover sprintList={sprints} roleId={roleId} />
          </div>

          {[1, 2, 3].includes(roleId) && (
            <Button
              onClick={handleExport}
              bg="#722ED1"
              color="white"
              size="sm"
              _hover={{ bg: '#5a1fb3' }}
              data-tour="export-data"
            >
              Export
            </Button>
          )}
            {roleId === 1 && (
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                padding: '10px 20px',
                background: '#fff',
              }}
            >
              <Switch
                checkedChildren="Admin"
                unCheckedChildren="Normal"
                checked={isAdminMode}
                onChange={setIsAdminMode}
              />
            </div>
          )}
          
        </div>
      </div>

      <Card
        style={{
          position: 'fixed',
          top: '280px',
          left: '100px',
          right: '20px',
          bottom: '20px',
          overflowX: 'auto',
          overflowY: 'auto',
        }}
      >
        {isLoading ? (
          <Flex justify="center" align="center" w="100%" h="300px" data-tour="kanban-board">
            <SkeletonWithLoaders />
          </Flex>
        ) : (
          <div style={{ position: 'relative', height: '100%' }} data-tour="kanban-board">
            {/* Spinner Overlay */}

            <div style={{ flex: 1, top: 0 }}>
              <div style={{ height: '100%', width: '100%' }}>
                <div style={{ height: '100%' }}>
                  <div
                    style={{
                      display: 'flex',
                      gap: '16px',
                      padding: '8px',
                      height: '100%',
                      boxSizing: 'border-box',
                    }}
                  >
                    <DndContext
                      sensors={sensors}
                      onDragStart={onDragStart}
                      onDragEnd={onDragEnd}
                      collisionDetection={(args) => {
                        // 1️⃣ Pointer is inside droppable (BEST)
                        const pointerCollisions = pointerWithin(args);
                        if (pointerCollisions.length > 0) {
                          return pointerCollisions;
                        }

                        // 2️⃣ Fallback to rectangle intersection
                        const rectCollisions = rectIntersection(args);
                        if (rectCollisions.length > 0) {
                          return rectCollisions;
                        }

                        // 3️⃣ Final fallback
                        return closestCenter(args);
                      }}
                    >
                      <SortableContext
                        items={columnOrder}
                        strategy={horizontalListSortingStrategy}
                      >
                        {columnOrder?.map((colId) => {
                          const statusObj = status?.find((s) => s.id === colId);
                          const TASK_MIN_HEIGHT = 130;
                          const COLUMN_HEADER_HEIGHT = 300;
                          const COLUMN_PADDING = 16;

                          const tallestTaskCount = Math.max(
                            0,
                            ...Object.values(taskStatusCount || {}),
                          );

                          const maxHeight =
                            tallestTaskCount * TASK_MIN_HEIGHT +
                            COLUMN_HEADER_HEIGHT +
                            COLUMN_PADDING;

                          return (
                            <DraggableColumnWrapper key={colId} id={colId}>
                              <DroppableColumn
                                columnKey={statusObj?.status_name}
                                columnId={colId}
                                renderCreate={renderCreate}
                                tasks={
                                  filteredTasks[statusObj?.status_name] || []
                                }
                                taskCount={taskStatusCount[statusObj?.status_name] || 0}
                                hovered={hoveredCol}
                                onHover={setHoveredCol}
                                assigneeList={assignedEmployee}
                                onOpenModal={handleOpenModal}
                                updateHeight={updateHeight}
                                handleOpenOptionMenu={handleOpenOptionMenu}
                                onDeleteColumn={(statusId) =>
                                  openDeleteModal(
                                    statusId,
                                    statusObj?.status_name,
                                  )
                                }
                                getTaskBoardDetails={getTaskBoardDetails}
                                maxHeight={maxHeight}
                              />
                            </DraggableColumnWrapper>
                          );
                        })}
                      </SortableContext>

                      <DragOverlay>
                        {activeId &&
                          (() => {
                            for (const col in tasks) {
                              const t = tasks[col].find(
                                (x) => x.id === activeId,
                              );
                              if (t) return <TaskCard task={t} />;
                            }
                            return null;
                          })()}
                      </DragOverlay>

                      {modalVisible && [1, 2, 3, 4, 5].includes(roleId) && (
                        <TaskModal
                          isOpen={modalVisible}
                          taskDetails={selectedTask}
                          onClose={handleCloseModal}
                          assigneeList={assignedEmployee}
                          statusList={status}
                          tasks={tasks}
                          getTaskBoardDetails={getTaskBoardDetails}
                          EpicList={epicList}
                          openSubtaskModal={handleopensubtaskmodal}
                          // Applyfilters={applyFilter}
                        />
                      )}

                      {subtaskmodal && selectedSubtask && (
                        <SubTaskModal
                          isOpen={subtaskmodal}
                          subtaskdetails={selectedSubtask}
                          onClose={handleclosesubtaskmodal}
                          taskDetails={selectedTask}
                          assigneeList={assignedEmployee}
                        />
                      )}

                      {optionMenuData.anchorRef && (
                        <OptionMenu
                          anchorRef={optionMenuData.anchorRef}
                          trigger={optionMenuData.trigger}
                          onClose={() =>
                            setOptionMenuData((prev) => ({
                              ...prev,
                              isOpen: false,
                            }))
                          }
                          task={optionMenuData.task}
                          status={status}
                          getTaskBoardDetails={getTaskBoardDetails}
                        />
                      )}

                      {showsprintmodal && sprints?.length > 0 && (
                        <SprintModal
                          isOpen={showsprintmodal}
                          onClose={() => setshowSprintModal(false)}
                          taskdetails={recentlyCreatedTask}
                          projectId={project_id.id}
                          getTaskBoardDetails={getTaskBoardDetails}
                          // Applyfilters={applyFilter}
                        />
                      )}

                      {showdeletestatusmodal && (
                        <Deletestatus
                          isOpen={showdeletestatusmodal}
                          onClose={() => Setdeletestatusmodal(false)}
                          selectedstatus={selectedStatus}
                          projectId={project_id.id}
                          statusList={status}
                          listBoardStatus={listBoardStatus}
                          tasks={tasks}
                        />
                      )}

                      {completesprintModal && (
                        <CompleteSprintModal
                          isOpen={completesprintModal}
                          onClose={() => setCompletesprintModal(false)}
                          projectId={project_id.id}
                          statusList={status}
                          getTaskBoardDetails={getTaskBoardDetails}
                        />
                      )}
                    </DndContext>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </Card>
    </Card>
  );
};

export default TaskManagementDashboard;
